module.exports = __webpack_public_path__ + "static/media/Hero_Image_Mobile_8.3acce990.jpg";